import EnhancedTable from '@common/components/Table/EnhancedTable'
import { HeadCell } from '@common/components/Table/table.types'
import { ReadTask } from '@common/config/api/client'
import { ROW_PER_PAGE_OPTIONS } from '@common/constants/table'
import { useParams } from 'react-router-dom'
import EnhancedTableBodyComplete from './EnhancedTableBodyComplete'
import { useSearch } from '@common/hooks/useSeach'
import { useReadTasksManagementHandlers } from '../../hooks/useReadTasksManagementHandlers'
import useGetReadDesignDetails from '@reader_task_list_view/hooks/useGetReadDesignDetails'
import { useMemo } from 'react'

interface ReaderTaskListTableCompleteProps {
  subjectId?: string
}

const headCells: readonly HeadCell<ReadTask>[] = [
  { id: 'subject_id', disablePadding: false, label: 'Subject ID', disableSort: false },
  { id: 'blind_code', disablePadding: true, label: 'Blind code', disableSort: false },
  { id: 'timepoint_pseudo_name', disablePadding: false, label: 'Timepoint', disableSort: false },
  { id: 'task_pseudo_id', disablePadding: true, label: 'Task pseudo ID', disableSort: false },
  { id: 'task_type', disablePadding: false, label: 'Type', disableSort: false },
  { id: 'priority', disablePadding: false, label: 'Priority', disableSort: false },
  { id: 'status', disablePadding: false, label: 'Status', disableSort: false },
  { id: 'created_at', disablePadding: false, label: 'Created at', disableSort: false },
  { id: 'completed_date', disablePadding: true, label: 'Completed at', disableSort: false },
  { id: 'due_date', disablePadding: true, label: 'Time spent', disableSort: true },
  { id: 'assignee', disablePadding: true, label: 'Assignee', disableSort: true },
]

export default function ReaderTaskListTableComplete({ subjectId }: ReaderTaskListTableCompleteProps) {
  const { studyId } = useParams()
  const { value } = useSearch()
  const { data: readDesigns } = useGetReadDesignDetails(studyId!)

  const defaultViewerIndex = useMemo(() => {
    if (!readDesigns) return 0
    if (readDesigns.some((d) => d.enable_raw_data)) return 2
    if (readDesigns.some((d) => d.type_of_gcis_viewer?.includes('bluerock'))) return 3
    return 0
  }, [readDesigns])

  const {
    order,
    orderBy,
    paginationParams,
    data,
    error,
    isLoading,
    handleRequestSort,
    handlePageChange,
    handleRowsPerPageChange,
  } = useReadTasksManagementHandlers({
    category: 'complete_tasks',
    studyId: studyId!,
    subjectId,
    searchValue: value,
  })

  if (isLoading) {
    return <div>Loading...</div>
  }
  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <EnhancedTable
      rows={data?.data?.items || []}
      headCells={headCells}
      order={order}
      orderBy={orderBy.split('.')[0] as keyof ReadTask}
      rowsPerPage={paginationParams.limit || 0}
      rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      next_cursor={data?.data?.pagination.next_cursor}
      previous_cursor={data?.data?.pagination.previous_cursor}
      onRequestSort={handleRequestSort}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handleRowsPerPageChange}
    >
      <EnhancedTableBodyComplete
        rows={data?.data?.items || []}
        order={order}
        orderBy={orderBy}
        defaultViewerIndex={defaultViewerIndex}
      />
    </EnhancedTable>
  )
}
